import { QueryKey } from '@tanstack/react-query';

export const openPositionsQueryKey: QueryKey = ['breezy', 'positions'];
